import React from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable, View } from 'react-native';
import { isContentBlocked, isContentHidden, isContentLocked } from 'Utils/parentalControlUtils';
import { getParentalRating, getProgressPercentage } from 'Utils/index';
import {
    createAdultLockedDescription,
    createLiveDescription,
    createNextDescription
} from 'LocalGluons/components/NowOnTvList/helpers';
import { Icon, LineIndicator } from 'LocalGluons/index';
import styles from 'LocalGluons/components/NowOnTvList/NowOnTvList.jss';
import { CachedImage } from 'LocalGluons/components/CachedImage';

const ListItem = ({
    channel,
    liveItem,
    nextItem,
    parentalLockConfig,
    onSelectChannel,
    onSelectProgram,
    isHighlighted,
    genreDataHide
}) => {
    const isAdult = liveItem.isAdult();
    if (isContentHidden(isAdult, parentalLockConfig)) return null;

    const adultLock = isContentLocked(isAdult, parentalLockConfig);
    const ageBlock = isContentBlocked(getParentalRating(liveItem.data), parentalLockConfig);
    const liveDescriptionData = adultLock
        ? createAdultLockedDescription(liveItem, genreDataHide)
        : createLiveDescription(liveItem, genreDataHide);
    const nextDescriptionData = adultLock
        ? createAdultLockedDescription(nextItem, genreDataHide)
        : createNextDescription(nextItem, genreDataHide);

    const isLockedOrBlocked = adultLock || ageBlock;

    const onIconSelected = () => {
        onSelectChannel(liveItem, nextItem);
    };

    const onRowSelected = () => {
        onSelectProgram(liveItem, nextItem);
    };

    return (
        <View style={[styles.itemContainer, isHighlighted && styles.highlightedItem]}>
            <Pressable style={styles.iconContainer} onPress={onIconSelected}>
                {isLockedOrBlocked ? (
                    <Icon name="lock" style={styles.lock} />
                ) : (
                    <CachedImage
                        source={{ uri: channel.logoUrl }}
                        style={styles.icon}
                        resizeMode="contain"
                    />
                )}
            </Pressable>
            <Pressable style={styles.rowContainer} onPress={onRowSelected}>
                <View style={styles.programRow}>
                    <Text
                        numberOfLines={1}
                        style={[styles.programTitle, styles.smallerText, styles.programTime]}
                    >
                        {liveDescriptionData.startTime}
                        {'\u00A0'}|{'\u00A0'}
                    </Text>
                    <Text numberOfLines={1} style={styles.programTitle}>
                        {liveDescriptionData.title}
                    </Text>
                </View>
                <View style={styles.programRow}>
                    <Text
                        numberOfLines={1}
                        style={[styles.programSubtitle, styles.smallerText, styles.programTime]}
                    >
                        {nextDescriptionData.startTime}
                        {'\u00A0'}|{'\u00A0'}
                    </Text>
                    <Text numberOfLines={1} style={[styles.programSubtitle, styles.smallerText]}>
                        {nextDescriptionData.title}
                    </Text>
                </View>
                <LineIndicator
                    style={styles.lineIndicatorHolder}
                    progress={getProgressPercentage(liveItem)}
                />
            </Pressable>
        </View>
    );
};

ListItem.propTypes = {
    channel: PropTypes.shape({}).isRequired,
    liveItem: PropTypes.shape({}).isRequired,
    nextItem: PropTypes.shape({}).isRequired,
    parentalLockConfig: PropTypes.shape({}).isRequired,
    onSelectChannel: PropTypes.func.isRequired,
    onSelectProgram: PropTypes.func.isRequired,
    isHighlighted: PropTypes.bool.isRequired
};

export default ListItem;
